import {Divider, Space, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const SeisPD = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Validation</Paragraph>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '-2%', textAlign: 'center'}}>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Carlos Alejandro Díaz Tufinio</Paragraph>
            <Text className='BaseText5'>Biotechnological Engineer that is consultant for a Contract Research Organization, third party labs, biopharma companies and biotech-based entrepreneurial projects. Appointed as a technical expert in analytical biosimilarity and statistical bioequivalence by the Mexican regulatory agency (COFEPRIS), as well as an active member in the Codex Alimentarius Mexican sub-committees. </Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>What regulations are in force for the project?</li>
                <li>Stablish the clinical trials for the approval of the project.</li>
                <li>How a biotech-enterprise must take into consideration?</li>
              </ul>
            </Text>
          </Content>
          <Content style={{width: 'fit-content', marginTop: '3%', background: 'transparent', marginRight: '10%'}}>
            <Image width="180%" height="auto" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-43.jpeg'/>
          </Content>
        </Space>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '3%', textAlign: 'center'}}>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image width="200%" height="auto" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-44.jpeg'/>
          </Content>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%', marginLeft: '40%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Laura Guerrero Medrano</Paragraph>
            <Text className='BaseText5'>Biochemistry PhD, specializing in oxidative stress, enzymology and toxicology. With experience in Environmental Biotechnology, Public Health and Toxicology; consultancy to companies and advice on Mexican regulations. Currently she is working on the development of a biosensor based on aptamers and on a solid waste management program.</Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>What is patenting a product?</li>
                <li>What is needed for a patent?</li>
                <li>How to make a patent?</li>
                <li>Types of investment funds for technological projects</li>
              </ul>
            </Text>
          </Content>
        </Space>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '3%', textAlign: 'center'}}>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Abingdon Health</Paragraph>
            <Text className='BaseText5'>Abingdon Health is a world leading developer and manufacturer of high-quality rapid lateral flow tests across all industry sectors, including healthcare, animal health and plant health. </Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>Insight in the manufacture considerations of our lateral flow assay</li>
                <li>Timelines for the production of our test</li>
                <li>Establish an agreement between both parties so that they are responsible for the manufacture of iMoAge</li>
              </ul>
            </Text>
          </Content>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image width="100%" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-45.png'/>
          </Content>
        </Space>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '3%', textAlign: 'center'}}>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image width="100%" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-46.jpg'/>
          </Content>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Tatiana Fiordelisio</Paragraph>
            <Text className='BaseText5'> Dr. Fiordelisio has more than 30 indexed scientific articles and is co-author of 3 book chapters. Likewise, it has 3 patents according to the Mexican Institute of Intellectual Property (IMPI).</Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>What stage of the project are you in?</li>
                <li>What is our Current State of Technology?</li>
                <li>Future steps of our project?</li>
                <li>How to reach a more mature technology?</li>
              </ul>
            </Text>
          </Content>
        </Space>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default SeisPD;
